import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6c045b6f")

_pushScopeId("data-v-6c045b6f")
const _hoisted_1 = { class: "modal-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withId(() => [
      _createVNode("div", {
        class: "modal modal-overlay",
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
      }, [
        _createVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default"),
          _createVNode(_component_font_awesome_icon, {
            class: "close-icon",
            icon: "times",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
          })
        ])
      ])
    ]),
    _: 3
  }))
})